<div class="filter-container">
    <div class="filter-header">
        <div class="filter-text1">{{ totalProperties }} Resultados</div>
        <button pButton pRipple type="button" (click)="clearFilters()" [disabled]="!hasActiveFilters()">
            <span class="px-2">Borrar filtros</span>
        </button>
    </div>

    <p-divider/>

    <div class="filter-section">
        <div class="filter-text1"><strong>Ordenar por</strong></div>
        <div class="flex flex-column gap-2">
            <div *ngFor="let option of sortOptions" class="field-checkbox">
                <p-radioButton [inputId]="option.value" name="sort" [value]="option.value"
                               [(ngModel)]="selectedSort" (ngModelChange)="emit()"/>
                <label [for]="option.value" class="ml-3 filter-text3">{{ option.label }}</label>
            </div>
        </div>
    </div>

    <div class="filter-section" *ngIf="offers?.length">
        <div class="filter-text1"><strong>Oferta</strong></div>
        <div class="flex flex-column gap-2">
            <div *ngFor="let offer of offers" class="field-checkbox">
                <p-radioButton [inputId]="'ad-' + offer.adId" name="offer" [value]="offer.adId"
                               [(ngModel)]="selectedAdId" (ngModelChange)="emit()"/>
                <label [for]="'ad-' + offer.adId" class="ml-3 filter-text3">{{ offer.adLabel }}</label>
            </div>
        </div>
    </div>

    <div class="filter-section" *ngIf="featureItems.length">
        <div class="filter-text1"><strong>Características</strong></div>
        <div class="flex flex-column gap-2">
            <div *ngFor="let feature of visibleFeatures" class="field-checkbox">
                <p-checkbox name="feature" [value]="feature.code"
                            [(ngModel)]="selectedFeatureCodes" (ngModelChange)="emit()"/>
                <label class="ml-3 filter-text3">{{ feature.label }}</label>
            </div>
            <a *ngIf="featureItems.length > 5" class="filter-link" (click)="featuresExpanded = !featuresExpanded">
                {{ featuresExpanded ? 'Ver menos' : 'Ver más' }}
            </a>
        </div>
    </div>

    <div class="filter-section">
        <div class="filter-text1"><strong>Precio</strong></div>
        <div class="filter-text2">Bolivianos</div>
        <p-slider [range]="true" [(ngModel)]="priceRange" [min]="priceMin" [max]="priceMax"
                  (onSlideEnd)="emit()"></p-slider>

        <div class="price-inputs">
            <div class="price-box">
                <div class="filter-text3">Mínimo</div>
                <input class="custom-input-price" type="text" [value]="priceRange[0]" pInputText readonly>
            </div>
            <div class="price-box">
                <div class="filter-text3">Máximo</div>
                <input class="custom-input-price" type="text" [value]="priceRange[1]" pInputText readonly>
            </div>
        </div>
    </div>
</div>
